import ComingSoonCover from "@/components/ComingSoonCover";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/profile/device/$id/_profile/configuration",
)({
  component: () => <ComingSoonCover />,
});
